import { render, staticRenderFns } from "./moritarot.vue?vue&type=template&id=42d9cced&"
import script from "./moritarot.vue?vue&type=script&lang=js&"
export * from "./moritarot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports